import { RegulationProposalAction } from 'app/model/CORE';
import { Filter } from 'app/common/table/Filter';
import Utils from 'app/common/util/Utils';
import MeasureUtils from 'app/common/util/MeasureUtils';
import { MonitoredMcdmMeasure } from 'app/model/SOL49';

export interface MeasureProposalFilterSettings {
    actions: RegulationProposalAction[];
    tvFilter: string;
    activeOnly: boolean;
}

export interface MeasureProposalFilter {
    name: string;
    filter: () => Filter<MonitoredMcdmMeasure>;
}

export class MeasureProposalActionFilter implements MeasureProposalFilter {
    name: string = 'MEASURE_PROPOSAL_ACTION_FILTER';
    private readonly actions: RegulationProposalAction[] = [];

    constructor(actions: RegulationProposalAction[]) {
        this.actions = actions;
    }

    filter = (): Filter<MonitoredMcdmMeasure> => {
        const filteredActions = this.actions;
        return {
            keep({ measure }: MonitoredMcdmMeasure): boolean {
                return (
                    Utils.isEmpty(filteredActions) ||
                    (MeasureUtils.isRegulationProposal(measure) && filteredActions.includes(measure.action)) ||
                    (MeasureUtils.isRerouting(measure) && filteredActions.includes(RegulationProposalAction.CREATION))
                );
            },
        };
    };
}

export class MeasureProposalTvFilter implements MeasureProposalFilter {
    name: string = 'MEASURE_PROPOSAL_TV_FILTER';
    private readonly tvFilter: string = '';

    constructor(tvFilter: string) {
        this.tvFilter = tvFilter;
    }

    filter = (): Filter<MonitoredMcdmMeasure> => {
        const textFilter = this.tvFilter.toUpperCase();
        return {
            keep({ measure }: MonitoredMcdmMeasure): boolean {
                const location = MeasureUtils.getTvLocation(measure);
                return (
                    location.id.includes(textFilter) ||
                    location.refLocation?.refId.includes(textFilter) ||
                    location.tvSetIds[0]?.includes(textFilter) ||
                    measure.measureId.id.includes(textFilter)
                );
            },
        };
    };
}

export class MeasureProposalActiveOnlyFilter implements MeasureProposalFilter {
    name: string = 'MEASURE_PROPOSAL_ACTIVE_ONLY_FILTER';
    private readonly activeOnly: boolean = true;

    constructor(activeOnly: boolean) {
        this.activeOnly = activeOnly;
    }

    filter = (): Filter<MonitoredMcdmMeasure> => {
        const activeOnly = this.activeOnly;
        return {
            keep(mcdmMeasure: MonitoredMcdmMeasure): boolean {
                return !activeOnly || MeasureUtils.isMcdmStateActive(mcdmMeasure.mcdmMeasureTopic.state);
            },
        };
    };
}
